import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import './index.scss';
import MainPage from './pages/main';
import { Route } from 'react-router';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      {/*// @ts-ignore*/}
      <Route exact path={'/'}>
        <MainPage />
      </Route>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);
